import React from "react";
import { Alert, Button, Card, Col, Nav, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { Route, Routes, useNavigate } from "react-router-dom";
import { logout } from "../academyStore/slices/AuthSlice";
import Footer from "../components/Footer";
import Mypayments from "./Mypayments";
import ProblemsCompare from "./ProblemsCompare";
import Profile from "./Profile";
import Wallet from "./Wallet";

const Dashboard = () => {
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLogged = useSelector((state) => state.user.isLoggedIn);
  const logoutHandler = () => {
    dispatch(logout());
    navigate("/");
  };
  return (
    <>
      <Row className="mx-0 stud-test pt-1 pb-5">
        <Col md={2} className="px-0 mbl-side">
          <Card className="shadow px-0 bg-side">
            <Card.Body className="px-0">
              <Nav className="flex-column">
                <LinkContainer to={"/dashboard"}>
                  <Nav.Link>My Account</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/mycourses"}>
                  <Nav.Link>My Courses</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/mywallet"}>
                  <Nav.Link>My Wallet</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/mypayments"}>
                  <Nav.Link>My Payments</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/myassignments"}>
                  <Nav.Link className="py-1">My Assignments</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/myresume"}>
                  <Nav.Link className="py-1">My Resume</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/interviewans"}>
                  <Nav.Link className="py-1">Interview Q&A</Nav.Link>
                </LinkContainer>
                <LinkContainer to={"/problems"}>
                  <Nav.Link className="py-1">Problems</Nav.Link>
                </LinkContainer>
                <hr className="my-1" />
                <Alert
                  variant="primary"
                  onClick={logoutHandler}
                  className="py-1 log mt-2 mb-0"
                >
                  <i className="fas fa-sign-out-alt"></i>&nbsp; Logout
                </Alert>
              </Nav>
            </Card.Body>
          </Card>
        </Col>
        <Col md={10} className="details">
          {/* <h4 className="py-2">Welcome {user[0].name}</h4> */}
          <Card className="shadow">
            <Card.Body>
              <Routes>
                <Route path="/dashboard" element={<Profile />} />
                <Route path="/mywallet" element={<Wallet />} />
                <Route path="/mypayments" element={<Mypayments />} />
                <Route path="/problems" element={<ProblemsCompare />} />
              </Routes>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Footer />
    </>
  );
};

export default Dashboard;
